import React from "react"
import { AuthenticationLayout } from "layoutsV2/client/AuthenticationLayout"
import { NewPassword as NewPasswordForm } from "ui/auth/NewPassword"

export const NewPassword = () => (
  <AuthenticationLayout type="signin">
    <NewPasswordForm />
  </AuthenticationLayout>
)
